import Decimal from 'decimal.js';
import { HUE_SEGMENT_SIZE } from '@/color/constants/hueWheel';
import { MUNSELL_HUES } from '@/color/constants/munsellHues';
import { MUNSELL_FINE_HUE_STEPS } from '../constants/munsellFineStepHues';
import { normalizeAngle } from '../types/Angle';
const HUE_TO_INDEX_MAP = new Map(MUNSELL_HUES.map((hue, index) => [hue.hue, index]));
export function getHueIndex(hue) {
    return HUE_TO_INDEX_MAP.get(hue);
}
export function getHueName(hueCode) {
    const suffixMap = {
        R: 'Red',
        YR: 'Yellow-Red',
        Y: 'Yellow',
        GY: 'Green-Yellow',
        G: 'Green',
        BG: 'Blue-Green',
        B: 'Blue',
        PB: 'Purple-Blue',
        P: 'Purple',
        RP: 'Red-Purple',
    };
    const match = hueCode.match(/[A-Z]+$/); // extract suffix
    if (!match) {
        throw new Error(`Invalid Munsell hue: ${hueCode}`);
    }
    const suffix = match[0];
    const fullName = suffixMap[suffix];
    if (!fullName) {
        throw new Error(`Unknown hue suffix: ${suffix}`);
    }
    return fullName;
}
export function getFullHueName(hue) {
    return `${getHueName(hue.hue)} (${hue.hue})`;
}
export function angleToHue(angle, edge = 'start') {
    const index = getHueIndexByAngle(angle, edge, HUE_SEGMENT_SIZE, MUNSELL_HUES.length);
    return MUNSELL_HUES[index];
}
export function angleToFineStepHue(angle, edge = 'start') {
    const index = getHueIndexByAngle(angle, edge, 360 / MUNSELL_FINE_HUE_STEPS.length, MUNSELL_FINE_HUE_STEPS.length);
    const fineStepHue = MUNSELL_FINE_HUE_STEPS[index];
    const hue = angleToHue(angle, edge);
    return {
        ...hue,
        hue: fineStepHue,
    };
}
function getHueIndexByAngle(angle, edge = 'start', segmentSize, huesLength) {
    const rawStep = new Decimal(normalizeAngle(angle)).div(segmentSize).toNumber();
    const index = edge === 'start' ? Math.floor(rawStep) : Math.ceil(rawStep);
    if (edge === 'end') {
        return index > 0 ? index - 1 : huesLength - 1;
    }
    return index;
}
